// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35L_W","field":"styles_field__3MWpb","fieldCol":"styles_fieldCol__3m_12","diffCol":"styles_diffCol__2AtZP","diff":"styles_diff__1SqtV"};